import { CookieEditOutlineIcon } from './CookieEditOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 0A7C1A34-8BC9-4A44-93F3-59F9235274AB
 * name cookie-edit-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-edit-outline.svg
 * tags
 * - Food / Drink 
 * - Edit / Modify 
 */
export const BiscuitEditOutlineIcon = CookieEditOutlineIcon;
export default BiscuitEditOutlineIcon